import { collection, getDocs, onSnapshot } from "firebase/firestore";
import { db, isFirebaseConfigured, collections } from "./firebase.js";

const empty = { users: [], addresses: [], schedules: [], orders: [] };

const readCollection = (name, onData, onError) =>
  onSnapshot(
    collection(db, collections[name]),
    (snap) => onData(snap.docs.map((item) => ({ id: item.id, ...item.data() }))),
    onError,
  );

/**
 * Live admin data. Every operational collection has its own listener.
 * Any create/update/delete in Firestore is reflected in the dashboard without refresh.
 */
export function subscribeToAdminData(onData, onError) {
  if (!isFirebaseConfigured() || !db) {
    onData(empty);
    return () => {};
  }

  let state = { ...empty };
  const update = (key) => (value) => {
    state = { ...state, [key]: value };
    onData(state);
  };

  const unsubscribers = [
    readCollection("users", update("users"), onError),
    readCollection("addresses", update("addresses"), onError),
    readCollection("schedules", update("schedules"), onError),
    readCollection("orders", update("orders"), onError),
  ];

  return () => unsubscribers.forEach((unsubscribe) => unsubscribe?.());
}

/** One-time snapshot for scripts or non-live pages. */
export async function getAdminData() {
  if (!isFirebaseConfigured() || !db) return empty;
  const entries = await Promise.all(
    Object.entries(collections)
      .filter(([key]) => ["users", "addresses", "schedules", "orders"].includes(key))
      .map(async ([key, name]) => {
        const snap = await getDocs(collection(db, name));
        return [key, snap.docs.map((item) => ({ id: item.id, ...item.data() }))];
      }),
  );
  return Object.fromEntries(entries);
}
